module.exports = new __parcel__URL__("writing.e73e757b.gif").toString();